import React from "react";
import { default as MuiButtonGroup } from "@mui/material/ButtonGroup";

function ButtonGroup(props) {
  return <MuiButtonGroup {...props} />;
}

export default ButtonGroup;
